<ng-container>
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title"
    [code]="code" [inputArea]="inputArea"
    [inputAreaPlaceholder]="inputAreaPlaceholder"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    (searchClick)="searchClick()" [validationRules]="validationRulesMap" [validationV2]="validationV2"
    (clear)="clear()">
</dk-ctl-sablon>

<dx-popup *ngIf="crudPopupVisible"
    title="Tms Taşınır Giris Bakiye Sorgulama"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-tms-tasinir-giris-bakiye-arama
          [state]="state"
          [islemFisCikisRowData]="islemFisCikisRowData"
          [selectedDetayRowInfo]="selectedDetayRowInfo"
          [newTasinirCikisi]="newTasinirCikisi"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-tms-tasinir-giris-bakiye-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
